/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'ล้างตัวเลือก',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'ไม่สามารถเรียกดูข้อมูลได้',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'คลิกเพื่อลองอีกครั้ง',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'กำลังโหลด...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'แสดงเพิ่มเติม',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} จาก {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'ไม่พบรายการที่ตรงกัน',
  'paginated-picker.async-select.select.option.error-message': 'ไม่สามารถเรียกดูข้อมูลได้',
  'paginated-picker.async-select.select.option.retry-message': 'คลิกเพื่อลองอีกครั้ง',
  'paginated-picker.async-select.select.search-placeholder': 'ค้นหา',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'แสดงรายการทั้งหมด'
};